import { HStack, Tooltip } from "@chakra-ui/react";
import { Card, FormRow, TextField } from "@components/ui-kit";
import { Trans, t } from "@lingui/macro";
import { Icon } from "@src/components/ui-kit/Icon";
import { WrapComponent } from "@src/utils/components/WrapComponent";
import { fieldToInputProps } from "@src/utils/forms/inputHelpers";
import { observer } from "mobx-react-lite";
import { Fragment } from "react";
import { useFetchLatestInternalNumber } from "../../hooks";
import { useStore } from "../../store";

export const Info = observer(function Info() {
  const store = useStore();
  const { form } = store;

  const internalNumber = useFetchLatestInternalNumber(form.type.value);

  return (
    <Card.Section>
      <FormRow title={t`Variable symbol`}>
        <TextField
          value={form.variable_symbol.value}
          error={form.variable_symbol.error}
          onChange={(value) => {
            form.variable_symbol.onChange(value.replace(/\D/g, ""));
          }}
          onKeyDown={(e) => {
            const { which, code, metaKey, altKey, ctrlKey, key } = e;

            const isSpace = code === "Space";
            const isNumber = code.includes("Digit") && Number(key) >= 0;
            const isLetter = code.includes("Key");
            const noMetaKeys = !metaKey && !altKey && !ctrlKey;
            const isSpecial = which >= 160;

            if (
              (isSpace || isSpecial || (isLetter && noMetaKeys)) &&
              !isNumber
            ) {
              e.preventDefault();
            }
          }}
        />
      </FormRow>
      {store.canUserAccess("symbols") && (
        <Fragment>
          <FormRow title={t`Constant symbol`}>
            <TextField {...fieldToInputProps(form.constant_symbol)} />
          </FormRow>
          <FormRow title={t`Specific symbol`}>
            <TextField {...fieldToInputProps(form.specific_symbol)} />
          </FormRow>
          <FormRow
            title={
              <WrapComponent
                if={!!internalNumber}
                with={(children) => (
                  <Tooltip
                    label={`${t`Last internal number`}: ${internalNumber}`}
                  >
                    {children}
                  </Tooltip>
                )}
              >
                <HStack>
                  <Trans>Internal number</Trans>
                  {!!internalNumber && (
                    <Icon
                      name="help-circle"
                      w="5"
                      h="5"
                      color="grey.400"
                      ml="1"
                    />
                  )}
                </HStack>
              </WrapComponent>
            }
          >
            <TextField {...fieldToInputProps(form.internal_number)} />
          </FormRow>
        </Fragment>
      )}
      <FormRow title={t`Document number`}>
        <TextField {...fieldToInputProps(form.document_number)} />
      </FormRow>
      <FormRow
        title={
          <Tooltip
            label={t`Information will be shown also in the payment order`}
          >
            <HStack>
              <Trans>Note</Trans>
              <Icon name="help-circle" w="5" h="5" color="grey.400" ml="1" />
            </HStack>
          </Tooltip>
        }
      >
        <TextField {...fieldToInputProps(form.note)} />
      </FormRow>
      <FormRow title={t`Internal note`}>
        <TextField {...fieldToInputProps(form.internal_note)} />
      </FormRow>
    </Card.Section>
  );
});
